export default __webpack_public_path__ + "static/page-not-found-f91c9c390c78888d5497c913ab245ab1.png";